import ContractsTaxiForwardingContractResponse, {
  ContractsTaxiForwardingContractResponseDataItem,
} from "../../../../api/raily/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract.response";
import ContractsTaxiForwardingContract, {
  ContractsTaxiForwardingContractItem,
} from "./contracts-taxi-forwarding-contract";

const createDataItem = (
  item: ContractsTaxiForwardingContractResponseDataItem,
): ContractsTaxiForwardingContractItem => {
  return {
    displayName: item.displayName,
    id: item.id,
  };
};

const createData = (
  responseData: ContractsTaxiForwardingContractResponseDataItem[],
): ContractsTaxiForwardingContractItem[] => {
  const items: ContractsTaxiForwardingContractItem[] =
    responseData.map(createDataItem);

  return items;
};

const create = (
  response: ContractsTaxiForwardingContractResponse,
): ContractsTaxiForwardingContract => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const contractsTaxiForwardingContractFactory = {
  create,
};

export default contractsTaxiForwardingContractFactory;
